import { render } from "./DialogUnlockingFailure.vue?vue&type=template&id=66d5a17a"
import script from "./DialogUnlockingFailure.vue?vue&type=script&lang=js"
export * from "./DialogUnlockingFailure.vue?vue&type=script&lang=js"
script.render = render

export default script